module.exports = __webpack_public_path__ + "media/shared/img/map_icon-64e1fe53aff52e31187544dda857fd68.png";